import { createContext } from "react";

export type AccordtionItemContextType = {
  handleClose: () => void;
  handleOpen: () => void;
  isOpen: boolean;
  name: string;
  /** True when this item was created with defaultOpen (skip initial open transitions). */
  openedByDefault: boolean;
};

export const AccordionItemContext = createContext<AccordtionItemContextType>({
  handleClose: () => {},
  handleOpen: () => {},
  isOpen: false,
  name: "",
  openedByDefault: false,
});
